import FixScroll from '../helpers/FixScroll'
import { overlayDebugLog } from '../helpers/overlayDebug'
import AudioPlayer from './AudioPlayer'
import ImageSwiper from './ImageSwiper'
import Animate from './Animate'
import Parallax from './Parallax'
import FetchArt from './FetchArt'
import { initOverlaySlider } from './overlay/slider'
import { trapFocus } from './overlay/swiperA11y'
import { renderMiniHeader, setMiniHeaderTheme, syncPaginationBullets } from './overlay/headerMini'
import { createPlayerManager } from './overlay/playerManager'
import {
  applyPlayerData,
  hideAudioPlayer,
  resetAudioInstance,
  setHasPlayer,
  showAudioPlayer,
} from './overlay/audioPlayerManager'

class OverlayLayer {
  constructor(id, targetId) {
    this.id = id
    this.targetId = targetId
    this.initialize()
  }

  initialize() {
    this.bindUI()
    this.bindEvents()
    this.displayOverlay()
  }

  bindUI() {
    this.ui = {}
    this.ui.$overlay = document.querySelector(`#${this.id}.js-overlay-ancestor`)
    if (!this.ui.$overlay) {
      console.error(`Overlay ancestor not found: #${this.id}`)
      return
    }
    this.ui.$page = this.ui.$overlay.querySelector(`${this.targetId}`)
    if (!this.ui.$page) {
      console.error(`Page not found: ${this.targetId}`)
      return
    }
    this.ui.$overlayHeader = this.ui.$page.querySelector('.js-overlay-header')
    this.ui.$overlayTitle = this.ui.$page.querySelector('.js-overlay-title')
    this.ui.$overlayHeaderMini = document.querySelector('.js-overlay-header-mini')
    this.ui.$slider = this.ui.$overlay.querySelector('.js-slider')
    this.ui.$overlayInner = this.ui.$page.querySelector('.js-overlay-inner')
    this.ui.$nexts = this.ui.$page.querySelectorAll('.js-next')
    this.ui.$next = this.ui.$page.querySelector('.overlay__next')
    this.ui.$slides = this.ui.$page.parentNode.querySelectorAll('.slider__cell')
    this.ui.$index = this.ui.$page.getAttribute('data-index')
    this.ui.$pagination = this.ui.$page.querySelector('.js-pagination')
    this.ui.$dots = [...this.ui.$page.querySelectorAll('.js-pagination .dot')]
    this.ui.$close = document.querySelector('.js-overlay-close')
    this.ui.$player = this.ui.$page.querySelector('.js-player-data')
    this.ui.$audioPlayer = document.querySelector('.js-player')
    this.ui.$imageSwiper = this.ui.$page.querySelectorAll('.js-image-swiper')
    this.nextOverlay = null
    this.touchstartX = 0;
    this.touchstartY = 0;
    this.touchendX = 0;
    this.touchendY = 0;
    window.imageswiper = []
    this.playerMgr = createPlayerManager()
    this._activeSlideCleanup = null
  }

  bindEvents() {
    for (let i = 0; i < this.ui.$nexts.length; i++) {
      const next = this.ui.$nexts[i];
      if (next != null) {
        next.addEventListener('click', this.onNext.bind(this))
      }
    }
  }

  displayOverlay() {
    if (!this.ui.$overlay) return

    if (this.ui.$overlay.classList.contains('is-scrolling')) {
      this.ui.$overlay.classList.remove('is-scrolling')
      this.ui.$overlay.parentNode.classList.remove('is-scrolling')
    }
    this.ui.$overlay.classList.add('is-active')
    this.ui.$overlay.classList.add('is-scrolling')
    this.ui.$overlay.parentNode.classList.add('is-scrolling')
    
    const closeButton = this.ui.$page.querySelector('.js-overlay-close')
    if (closeButton) {
      closeButton.addEventListener('click', this.onClose.bind(this))
    }

    FixScroll.fix()

    if (window.audioplayer) {
      this.removePlayerData()
    }
    this.hidePlayer()

    window.lazyvideo.initialize()

    setTimeout(() => {
      if (this.ui.$overlayHeaderMini) {
        const headerCloseButton = this.ui.$overlayHeaderMini.querySelector('.js-overlay-close')
        if (headerCloseButton) {
          headerCloseButton.addEventListener('click', this.onClose.bind(this))
        }
      }
      
      if (this.ui.$overlay) {
        this.ui.$overlay.addEventListener('scroll', this.onScroll.bind(this))
      }

      const self = this

      if (window.sliderdefault) {
        window.sliderdefault.update()
        
        let arts = [...window.sliderdefault.slides[window.sliderdefault.activeIndex].querySelectorAll('.js-art-link')]
        if (arts.length > 0) {
          arts.forEach(element => {
            window.fetchart = new FetchArt(element, true)
          });
        }

        window.sliderdefault.on('slideChange', function () {
          window.overlaylayer.ui.$overlay.scrollTo(0, 0);
          let activeSlide = window.sliderdefault.slides[window.sliderdefault.activeIndex]
          let close = activeSlide.querySelector('.js-overlay-close')
          close.addEventListener('click', self.onClose.bind(self))

          let imageswipers = activeSlide.querySelectorAll('.js-image-swiper')
          if (imageswipers.length > 0) {
            imageswipers.forEach(imageSwiper => {
              window.imageswiper.push(new ImageSwiper(imageSwiper))
            });
          }

          let next = activeSlide.querySelector('.js-next')
          if (next != null) {
            next.addEventListener('click', self.onNext.bind(self))
          }

          let images = activeSlide.querySelectorAll('.js-parallax')
          if (images.length > 0) {
            window.parallax = new Parallax(images)
          }

          let arts = [...activeSlide.querySelectorAll('.js-art-link')]
          if (arts.length > 0) {
            arts.forEach(element => {
              window.fetchart = new FetchArt(element, true)
            });
          }

          window.animate = new Animate()

          let player = activeSlide.querySelector('.js-player-data')
          if (player != null) {
            if (window.audioplayer != undefined) {
              self.removePlayerData()
            }
            self.addPlayerData(player)
          } else {
            self.hidePlayer()
          }

          let overlayClose = activeSlide.querySelector('.js-overlay-close')
          let overlayTitle = activeSlide.querySelector('.js-overlay-title')
          let overlayPagination = activeSlide.querySelector('.js-pagination')
          const { close: overlayCloneClose, pagination } = renderMiniHeader(
            self.ui.$overlayHeaderMini,
            {
              closeEl: overlayClose,
              titleEl: overlayTitle,
              paginationEl: overlayPagination,
            }
          )
          syncPaginationBullets(pagination, window.sliderdefault.activeIndex)
          setMiniHeaderTheme(self.ui.$overlayHeaderMini, activeSlide)

          if (overlayCloneClose) {
            overlayCloneClose.addEventListener('click', self.onClose.bind(self))
          }

          let id = activeSlide.querySelector('.js-overlay-child').getAttribute('data-id')
          let pathUrl

          window.fetchdata.items.forEach(item => {
            if (item.id == id) {
              pathUrl = new URL(item.url)
            }
          });
        })
      }

      this.ui.$overlay.parentNode.classList.add('animate-in')
      this.ui.$overlay.parentNode.classList.remove('animate-out')
      document.body.classList.add('overlay-is-active')
      document.documentElement.classList.add('overlay-is-active')

      if (this.ui.$imageSwiper.length > 0) {
        this.ui.$imageSwiper.forEach(imageSwiper => {
          window.imageswiper.push(new ImageSwiper(imageSwiper))
        });
      }

      for (let i = 0; i < window.video.length; i++) {
        const video = window.video[i]
        if (!video.isMute) {
          video.mute()
        }
      }

      if (this.ui.$player != null) {
        showAudioPlayer(this.ui.$audioPlayer)
        setHasPlayer(this.ui.$overlay, true)
        
        requestAnimationFrame(() => {
          this.addPlayerData(this.ui.$player)
        })
      } else {
        this.hidePlayer()
      }

    }, 300)
  }

  onNext(e) {
    let target = e.target
    if (!target.matches('.js-next')) return

    let ancestorId = target.getAttribute('data-parent-id')
    let targetId = target.getAttribute('data-target')

    if (!ancestorId || !targetId) {
      console.error('Missing required attributes: data-parent-id or data-target')
      return
    }

    if (window.audioplayer) {
      this.hidePlayer()
    }

    this.removeOverlay()

    setTimeout(() => {
      window.overlaylayer = new OverlayLayer(ancestorId, targetId)
      let slider = window.overlaylayer.ui.$overlay.querySelector('.js-slider')
      if (!slider) {
        console.error('Slider not found')
        return
      }
      let activeIndex = Array.from(slider.querySelectorAll('.swiper-slide')).indexOf(slider.querySelector(targetId))
      let targetSlide = slider.querySelector(targetId)
      if (!targetSlide) {
        console.error('Target slide not found:', targetId)
        return
      }
      let initialSlideIndex = targetSlide.getAttribute('data-index')
      if (!initialSlideIndex) {
        console.error('No data-index found on target slide')
        return
      }

      window.sliderdefault = initOverlaySlider(slider, {
        initialSlide: activeIndex,
        onActiveSlide: (slideEl) => {
          if (this._activeSlideCleanup) this._activeSlideCleanup()
          this._activeSlideCleanup = null

          const playerEl = document.querySelector('.js-player')
          const extraFocusable = playerEl
            ? Array.from(
                document.querySelectorAll(
                  '.js-player-toggle, .js-player-transcript, .js-player-transcript-close'
                )
              )
            : []

          this._activeSlideCleanup = trapFocus(slideEl, {
            additionalFocusable: extraFocusable,
            alsoBindTo: [playerEl],
            onEscape: () => {
              slideEl.setAttribute('aria-hidden', 'true')
              window.overlaylayer.onClose(slideEl.querySelector('.js-overlay-close'))
            },
          })
        },
        swiperOptions: {
          slidesPerView: 'auto',
        },
      })

      let activeSlide = window.sliderdefault.slides[window.sliderdefault.activeIndex]
      if (!activeSlide) {
        console.error('No active slide found')
        return
      }

      window.sliderdefault.update()
      let overlayClose = activeSlide.querySelector('.js-overlay-close')
      let overlayTitle = activeSlide.querySelector('.js-overlay-title')
      let overlayPagination = activeSlide.querySelector('.js-pagination')

      const { title, pagination } = renderMiniHeader(this.ui.$overlayHeaderMini, {
        closeEl: overlayClose,
        titleEl: overlayTitle,
        paginationEl: overlayPagination,
      })
      syncPaginationBullets(pagination, window.sliderdefault.activeIndex)

      let images = activeSlide.querySelectorAll('.js-parallax')
      if (images.length > 0) {
        window.parallax = new Parallax(images)
      }

      if (!window.location.href.includes('singleurl')) {
        let arts = [...activeSlide.querySelectorAll('.js-art-link')]
        if (arts.length > 0) {
          arts.forEach(element => {
            window.fetchart = new FetchArt(element, true)
          });
        }
      }

      setMiniHeaderTheme(this.ui.$overlayHeaderMini, activeSlide)

      let id = activeSlide.querySelector('.js-overlay-child').getAttribute('data-id')
      let pathUrl

      window.fetchdata.items.forEach(item => {
        if (item.id == id) {
          pathUrl = new URL(item.url)
        }
      });

      window.dataLayer.push({
        'event': 'page_view',
        'page_path': pathUrl.pathname,
        'page_title': (title && title.innerText) ? title.innerText : (overlayTitle ? overlayTitle.innerText : '')
      });

      overlayDebugLog('OverlayLayer.onNext → overlay:opened', {
        overlayId: this.id,
        targetId,
        activeIndex: window.sliderdefault.activeIndex,
        childId: id,
      })
      window.dispatchEvent(new CustomEvent('overlay:opened', { bubbles: true }))

      this.playerMgr.moveInto(activeSlide)

      let playerData = activeSlide.querySelector('.js-player-data')
      if (playerData) {
        setTimeout(() => {
          if (window.audioplayer) {
            this.removePlayerData()
          }
          this.addPlayerData(playerData)
        }, 100)
      }
    }, 700)
  }

  onScroll(e) {
    let target = e.currentTarget
    let scrollPos = target.scrollTop
    let headerBottomPos = this.ui.$overlayHeader.offsetHeight

    window.sliderdefault.update()

    target.classList.add('is-scrolling')
    target.parentNode.classList.add('is-scrolling')

    if (scrollPos > headerBottomPos) {
      this.ui.$overlayHeaderMini.classList.add('is-visible')
    } else {
      this.ui.$overlayHeaderMini.classList.remove('is-visible')
    }
  }

  onClose(e) {
    let target = e.currentTarget || e
    if (!target.matches('.js-overlay-close')) return


    this.removeOverlay()
    window.history.replaceState(null, null, window.location.pathname);

    for (let i = 0; i < window.video.length; i++) {
      const video = window.video[i]
      if (!video.isMute) {
        video.mute()
      }
    }
  }

  removeOverlay() {
    window.dispatchEvent(new CustomEvent('overlay:closed', { bubbles: true }))
    document.querySelector('.hdr-logo-link').focus()
    if (this.ui.$overlayHeaderMini) {
      this.ui.$overlayHeaderMini.classList.remove('is-visible')
      this.ui.$overlayHeaderMini.classList.remove('overlay-header-mini--dark')
      this.ui.$overlayHeaderMini.innerHTML = ""
    }

    if (window.sliderdefault) {
      window.sliderdefault.destroy(true, true)
      window.sliderdefault = undefined
    }

    if (window.parallax != undefined && window.parallax.els.length > 0) {
      window.parallax.instance.destroy()
      window.parallax = undefined
    }

    if (window.imageswiper && window.imageswiper.length > 0) {
      window.imageswiper.forEach(swiper => {
        if (swiper && swiper.destroy) {
          swiper.destroy(true, true)
        }
      })
      window.imageswiper = []
    }

    this.playerMgr.restore()

    window.overlaylayer.ui.$overlay.scrollTo(0, 0)

    if (window.animate) {
      window.animate.elements.forEach(element => {
        if (!element.classList.contains('card')) {
          element.classList.remove('is-visible')
        }
      })
    }

    let player = this.ui.$overlay.querySelector('.js-player-data')
    if (player != null || this.ui.$player != null) {
      this.hidePlayer()
      setHasPlayer(this.ui.$overlay, false)
    }

    let thumbnails = document.querySelectorAll('.thumbnail')
    for (let i = 0; i < thumbnails.length; i++) {
      thumbnails[i].classList.remove('is-animate')
    }

    this.ui.$overlay.parentNode.classList.remove('animate-in')
    this.ui.$overlay.parentNode.classList.add('animate-out')
    this.ui.$overlay.classList.remove('is-active')
    this.ui.$overlay.classList.remove('is-scrolling')
    this.ui.$overlay.parentNode.classList.remove('is-scrolling')

    document.body.classList.remove('overlay-is-active')
    document.documentElement.classList.remove('overlay-is-active')

    FixScroll.unFix()

    setTimeout(() => {
      window.overlaylayer = undefined
      this.ui.$overlayHeaderMini.innerHTML = ""
    }, 100)
  }

  addPlayerData(player) {
    applyPlayerData({ audioPlayerEl: this.ui.$audioPlayer, overlayEl: this.ui.$overlay, dataEl: player })
  }

  removePlayerData() {
    resetAudioInstance()
  }

  hidePlayer() {
    try {
      hideAudioPlayer(this.ui.$audioPlayer)

      if (window.audioplayer != undefined) {
        this.removePlayerData()
      }

      const audioPlayerTitle = this.ui.$audioPlayer.querySelector('.js-player-title')
      const audioPlayerCover = this.ui.$audioPlayer.querySelector('.js-player-cover')

      if (audioPlayerTitle) audioPlayerTitle.textContent = ''
      if (audioPlayerCover) audioPlayerCover.src = ''

      setHasPlayer(this.ui.$overlay, false)
    } catch (error) {
      console.error('Error in hidePlayer:', error)
    }
  }
}

export default OverlayLayer
